// extracted by mini-css-extract-plugin
module.exports = {"buttonLink":"noOfJobsButton_buttonLink__EHOap"};